<template>
  <div>
  </div>
</template>


<script>
// 线上
const url = "http://106.52.65.234:8098";

// 线上
const urls = "http://106.52.65.234:8099";


export default {
  url,urls
}
</script>